export * from './herausgebers-sorter.component';
export * from './herausgebers-sorter.component.module';